import React from 'react';
import { CheckTag } from '../../../../common';
import './style.scss';

const tags = ['Suite', 'Floor', 'Address', 'ZIP + 4', 'ZIP Code', 'Near Net', 'Census Block'];
export const TagBlock = () => (
  <div className="tag_block">
    {tags.map(tag => <CheckTag key={tag}>{tag}</CheckTag>)}
  </div>
);



// WEBPACK FOOTER //
// ./src/view/screens/Project/components/TagBlock/index.js